import FlexContainer from "@components/FlexContainer/FlexContainer";
import { Leaf } from "@components/Leaf/Leaf";
import { LEAF_COLORS, THEME_COLOR } from "@utils/Constants";
import { Tooltip as ReactTooltip } from "react-tooltip";

function Leaves({
    leafHeight = 40,
    leafWidth = 40,
    laufidCompany,
    onClick,
    style,
    className,
    leafClassName,
    leafBackground = "white",
}) {
    const uid = laufidCompany?.id || Math.random().toString(36).slice(2, 8);
    const tooltipKeys = [`umhverfi-${uid}`, `felag-${uid}`, `stjorn-${uid}`];

    let greenSteps = laufidCompany?.green_step_category_count;
    if (greenSteps) {
        greenSteps = Object.keys(greenSteps).map((key) => ({
            name: key,
            total_category_green_steps: greenSteps[key],
        }));
    }
    return (
        <FlexContainer
            style={{
                flex: 1,
                justifyContent: "space-between",
                ...style,
            }}
            className={className}
        >
            {greenSteps?.length > 0 && (
                <>
                    {tooltipKeys.map((id, i) => (
                        <ReactTooltip
                            key={id}
                            place="bottom"
                            id={id}
                            style={{
                                backgroundColor: LEAF_COLORS[i].active,
                                borderRadius: 900,
                                color: "white",
                                padding: "5px 15px",
                                boxShadow: "0 0 5px #0000000a",
                                zIndex: 100,
                            }}
                        />
                    ))}
                </>
            )}
            {!greenSteps &&
                [0, 0, 0].map((leaf, index) => (
                    <Leaf
                        key={index}
                        title={leaf.name}
                        activeColor={LEAF_COLORS[index].active}
                        inactiveColor={LEAF_COLORS[index].inactive}
                        style={{
                            color: leafBackground,
                            height: leafHeight,
                            width: leafWidth,
                        }}
                    />
                ))}
            {greenSteps?.map((step, index) => (
                <Leaf
                    onClick={(e) => {
                        if (onClick) {
                            e.preventDefault();
                        }
                        onClick?.(index);
                    }}
                    key={step.id || index}
                    className={leafClassName}
                    activeColor={LEAF_COLORS[index].active}
                    inactiveColor={LEAF_COLORS[index].inactive}
                    percentage={step.total_category_green_steps / 100}
                    data-tooltip-id={tooltipKeys[index]}
                    data-tooltip-content={
                        step.name +
                        " - " +
                        step.total_category_green_steps +
                        "%"
                    }
                    style={{
                        height: leafHeight,
                        width: leafWidth,
                    }}
                />
            ))}
        </FlexContainer>
    );
}
export default Leaves;
